import types from '@/store/types';

export default {
  [types.GET_STATS]({
    state,
    commit,
    getters,
  }) {
    return getters.statsCollection
      .get().then((querySnapshot) => {
        const results = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.modifiedAt) {
            data.modifiedAt = data.modifiedAt.seconds * 1000;
          }
          results.push({
            id: doc.id,
            ...data,
          });
        });
        state.has_stats_loaded = true;
        state.stats_list = results;
        return results;
      })
      .catch((error) => {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, {
          root: true,
        });
        throw error;
      });
  },
  [types.GET_DASHBOARD_STATS]({
    state,
    commit,
    getters,
  }) {
    return getters.dashboardStats
      .get().then((querySnapshot) => {
        const doc = querySnapshot.data();
        state.has_dashboard_stats_loaded = true;
        state.dashboard_stats_list = doc;
        return doc;
      })
      .catch((error) => {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, {
          root: true,
        });
        throw error;
      });
  },
};
